var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGarbage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1400",
    "data-name": "Rectangle 1400",
    width: 29.419,
    height: 34.785
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Garbage"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Garbage",
    clipPath: "url(#clip-Garbage)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1559",
    "data-name": "Groupe 1559",
    transform: "translate(8 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1558",
    "data-name": "Groupe 1558",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6621",
    "data-name": "Trac\\xE9 6621",
    d: "M29.419,3.44H20.808V1.74A1.739,1.739,0,0,0,19.068,0H10.351a1.739,1.739,0,0,0-1.74,1.74v1.7H0v1.6H2.99v26.4a3.356,3.356,0,0,0,3.346,3.346H23.069a3.335,3.335,0,0,0,3.346-3.346V5.043h3ZM8.679,30.468H7.123V7.16H8.679Zm6.81,0H13.933V7.16h1.556Zm6.81,0H20.743V7.16H22.3ZM11.8,1.74a.575.575,0,0,1,.569-.569h4.675a.575.575,0,0,1,.569.569v1.7H11.8Z",
    transform: "translate(0 0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarbage);
export default __webpack_public_path__ + "static/media/Garbage.b255632343767e02fefdb4995b514a6c.svg";
export { ForwardRef as ReactComponent };